export const MOBILE_ADDRESS_SIZE = 10
export const DESKTOP_ADDRESS_SIZE = 14
